module.exports = __webpack_public_path__ + "static/media/11 (2).7a93fd83.jpg";